import { PerspectiveCamera, OrthographicCamera } from "three"

/*****************************************************************
 * Camera provider
 * ***************************************************************/

export const 
    MainCamera = new OrthographicCamera(-1, 1, 1, -1, 100, 500),
    FrontCamera = new OrthographicCamera(-1, 1, 1, -1, 100, 500),
    TopCamera = new OrthographicCamera(-1, 1, 1, -1, 100, 500),
    BottomCamera = new OrthographicCamera(-1, 1, 1, -1, 100, 500),
    GnomonCamera = new PerspectiveCamera(50, 1, 1, 100),
    ComparativeCamera = new OrthographicCamera(-1, 1, 1, -1, 100, 500)
